import React, { useState, useEffect } from 'react';
import MaterialTable from 'material-table'
import Moment from 'react-moment';
import {
    useParams
  } from "react-router-dom";

export default function CreateTournament() {

    let { id } = useParams();

    useEffect(() => {
      
    }, [])

    return (
        <div>
            <h2>Créer un tournois</h2>
            <h1>{ id }</h1>
        </div>
    );
}